import l from "lodash/isArrayLikeObject";
import u from "lodash/isDate";
import { isObject as o, mixinOptionalProps as c } from "./helpers.js";
import m from "./locale.js";
const p = 24 * 60 * 60 * 1e3;
function f(D, t) {
  const e = new Date(D);
  return e.setDate(e.getDate() + t), e;
}
class i {
  constructor(t, { locale: e = new m() } = {}) {
    if (this.isDateInfo = !0, this.isRange = o(t) || typeof t == "function", this.isDate = !this.isRange, this.locale = e, this.mask = e.masks.data, this.getMonthComps = e.getMonthComps, this.firstDayOfWeek = e.firstDayOfWeek, this.isDate) {
      this.type = "date";
      let s = this.toDate(t);
      s = u(s) ? s : /* @__PURE__ */ new Date(), s.setHours(0, 0, 0, 0), this.date = s, this.dateTime = s.getTime();
    }
    if (this.isRange) {
      if (this.type = "range", typeof t == "function")
        this.on = { and: t };
      else {
        let s = this.toDate(t.start), n = this.toDate(t.end);
        if (s && n && s > n) {
          const r = s;
          s = n, n = r;
        } else s && t.span >= 1 && (n = f(s, t.span - 1));
        s && (u(s) ? s.setHours(0, 0, 0, 0) : s = null), n && (u(n) ? n.setHours(0, 0, 0, 0) : n = null), this.start = s, this.end = n, this.startTime = s && s.getTime(), this.endTime = n && n.getTime(), s && n && (this.daySpan = this.diffInDays(s, n), this.weekSpan = this.diffInWeeks(s, n), this.monthSpan = this.diffInMonths(s, n), this.yearSpan = this.diffInYears(s, n));
        const a = c(t, {}, i.patternProps);
        if (a.assigned && (this.on = { and: a.target }), t.on) {
          const r = (l(t.on) ? t.on : [t.on]).map((h) => {
            if (typeof h == "function")
              return h;
            const d = c(h, {}, i.patternProps);
            return d.assigned ? d.target : null;
          }).filter((h) => h);
          r.length && (this.on = {
            ...this.on,
            or: r
          });
        }
      }
      this.isComplex = !!this.on;
    }
  }
  toDate(t) {
    const e = this.locale.masks.data;
    return this.locale.toDate(t, e);
  }
  // Returns a date range that intersects two DateInfo objects
  // NOTE: This is a shallow calculation (does not take patterns into account),
  // so this method should only really be called for special conditions
  // where absolute accuracy is not necessarily needed
  findShallowIntersectingRange(t, e) {
    const s = t.toRange(), n = e.toRange();
    let a = null, r = null;
    return s.start ? n.start ? a = s.start < n.start ? s.start : n.start : a = s.start : n.start && (a = n.start), s.end && (!a || s.end >= a) && (r = s.end), n.end && (!a || n.end >= a) && (!r || n.end < r) && (r = n.end), { start: a, end: r };
  }
  startOfWeek(t) {
    const e = t.getDay() + 1, s = e >= this.firstDayOfWeek ? this.firstDayOfWeek - e : -(7 - (this.firstDayOfWeek - e));
    return f(t, s);
  }
  diffInDays(t, e) {
    return Math.round((e - t) / p);
  }
  diffInWeeks(t, e) {
    return this.diffInDays(this.startOfWeek(t), this.startOfWeek(e));
  }
  diffInYears(t, e) {
    return e.getUTCFullYear() - t.getUTCFullYear();
  }
  diffInMonths(t, e) {
    return this.diffInYears(t, e) * 12 + (e.getMonth() - t.getMonth());
  }
  static get patterns() {
    return {
      dailyInterval: {
        test: (t, e, s) => s.diffInDays(s.start || /* @__PURE__ */ new Date(), t.date) % e === 0
      },
      weeklyInterval: {
        test: (t, e, s) => s.diffInWeeks(s.start || /* @__PURE__ */ new Date(), t.date) % e === 0
      },
      monthlyInterval: {
        test: (t, e, s) => s.diffInMonths(s.start || /* @__PURE__ */ new Date(), t.date) % e === 0
      },
      yearlyInterval: {
        test: () => (t, e, s) => s.diffInYears(s.start || /* @__PURE__ */ new Date(), t.date) % e === 0
      },
      days: {
        validate: (t) => l(t) ? t : [parseInt(t, 10)],
        test: (t, e) => e.includes(t.day) || e.includes(-t.dayFromEnd)
      },
      weekdays: {
        validate: (t) => l(t) ? t : [parseInt(t, 10)],
        test: (t, e) => e.includes(t.weekday)
      },
      ordinalWeekdays: {
        validate: (t) => Object.keys(t).reduce((e, s) => {
          const n = t[s];
          return n && (e[s] = l(n) ? n : [parseInt(n, 10)]), e;
        }, {}),
        test: (t, e) => Object.keys(e).map((s) => parseInt(s, 10)).find(
          (s) => e[s].includes(t.weekday) && (s === t.weekdayOrdinal || s === -t.weekdayOrdinalFromEnd)
        )
      },
      weekends: {
        validate: (t) => t,
        test: (t) => t.weekday === 1 || t.weekday === 7
      },
      workweek: {
        validate: (t) => t,
        test: (t) => t.weekday >= 2 && t.weekday <= 6
      },
      weeks: {
        validate: (t) => l(t) ? t : [parseInt(t, 10)],
        test: (t, e) => e.includes(t.week) || e.includes(-t.weekFromEnd)
      },
      months: {
        validate: (t) => l(t) ? t : [parseInt(t, 10)],
        test: (t, e) => e.includes(t.month)
      },
      years: {
        validate: (t) => l(t) ? t : [parseInt(t, 10)],
        test: (t, e) => e.includes(t.year)
      }
    };
  }
  static get patternProps() {
    return Object.keys(i.patterns).map((t) => ({
      name: t,
      validate: i.patterns[t].validate
    }));
  }
  static testConfig(t, e, s) {
    return typeof t == "function" ? t(e) : o(t) ? Object.keys(t).every((n) => i.patterns[n].test(e, t[n], s)) : null;
  }
  iterateDatesInRange({ start: t, end: e }, s) {
    if (!t || !e || typeof s != "function")
      return null;
    const n = {
      i: 0,
      date: t,
      day: this.locale.getDayFromDate(t),
      finished: !1
    };
    let a = null;
    for (; !n.finished && n.date <= e; n.i++)
      a = s(n), n.date = f(n.date, 1), n.day = this.locale.getDayFromDate(n.date);
    return a;
  }
  // Determines if this date partially intersects another date
  // NOTE: This is a deep test (patterns tested)
  intersectsDate(t) {
    const e = t.isDateInfo ? t : new i(t, { locale: this.locale });
    if (!this.shallowIntersectsDate(e))
      return null;
    if (!this.on)
      return this;
    const s = this.findShallowIntersectingRange(this, e);
    let n = !1;
    return this.iterateDatesInRange(s, (a) => {
      this.matchesDay(a.day) && (n = n || e.matchesDay(a.day), a.finished = n);
    }), n;
  }
  // Determines if this date partially intersects another date
  // NOTE: This is a shallow test (no patterns tested)
  shallowIntersectsDate(t) {
    return this.dateShallowIntersectsDate(
      this,
      t.isDate ? t : new i(t, { locale: this.locale })
    );
  }
  // Determines if first date partially intersects second date
  // NOTE: This is a shallow test (no patterns tested)
  dateShallowIntersectsDate(t, e) {
    return t.isDate ? e.isDate ? t.dateTime === e.dateTime : this.dateShallowIncludesDate(e, t) : e.isDate ? this.dateShallowIncludesDate(t, e) : !(t.start && e.end && t.start > e.end || t.end && e.start && t.end < e.start);
  }
  // Determines if this date completely includes another date
  // NOTE: This is a deep test (patterns tested)
  includesDate(t) {
    const e = t.isDateInfo ? t : new i(t, { locale: this.locale });
    if (!this.shallowIncludesDate(e))
      return !1;
    if (!this.on)
      return !0;
    const s = this.findShallowIntersectingRange(this, e);
    let n = !0;
    return this.iterateDatesInRange(s, (a) => {
      this.matchesDay(a.day) && (n = n && e.matchesDay(a.day), a.finished = !n);
    }), n;
  }
  // Determines if this date completely includes another date
  // NOTE: This is a shallow test (no patterns tested)
  shallowIncludesDate(t) {
    return this.dateShallowIncludesDate(this, t.isDate ? t : new i(t, { locale: this.locale }));
  }
  // Determines if first date completely includes second date
  // NOTE: This is a shallow test (no patterns tested)
  dateShallowIncludesDate(t, e) {
    return t.isDate ? e.isDate ? t.dateTime === e.dateTime : !e.startTime || !e.endTime ? !1 : t.dateTime === e.startTime && t.dateTime === e.endTime : e.isDate ? !(t.start && e.date < t.start || t.end && e.date > t.end) : !(t.start && (!e.start || e.start < t.start) || t.end && (!e.end || e.end > t.end));
  }
  includesDay(t) {
    return this.shallowIncludesDate(t.date) && this.matchesDay(t) ? this : null;
  }
  matchesDay(t) {
    return this.on ? !(this.on.and && !i.testConfig(this.on.and, t, this) || this.on.or && !this.on.or.some((e) => i.testConfig(e, t, this))) : !0;
  }
  toRange() {
    return this.isDate ? new i(
      {
        start: this.date,
        end: this.date
      },
      { locale: this.locale }
    ) : new i(
      {
        start: this.start,
        end: this.end
      },
      { locale: this.locale }
    );
  }
}
export {
  f as addDays,
  i as default
};
//# sourceMappingURL=date-info.js.map
